import { Outlet } from "react-router-dom";
import "../../styles/index.css";
import { assetsUrl } from "../../constants";
import { getRegionByTimezone } from "../../utilis/methods/region";
// function getYear() {
//   const date = new Date();
//   const year = date.getFullYear();
//   return year;
// }
export const AuthLayout = () => {
  return (
    <div className="flex justify-center items-center h-[100dvh] bg-slate-100">
      <div className="h-[90dvh] w-[95%] grid grid-cols-12 drop-shadow-2xl ">
        <div className="col-span-6 h-[90dvh] w-[100%] bg-white rounded-bl-3xl rounded-tl-3xl">
          <div className="col-span-12 flex flex-col items-center justify-between h-[90dvh] w-[100%] rounded-tr-[150px] rounded-tl-3xl  rounded-bl-[150px] gradient1 py-8">
            <div className=" w-full">
              {getRegionByTimezone() == "QA" && (
                <img
                  width="155px"
                  height={"15px"}
                  src={`${assetsUrl}/logos/NETDENT.png`}
                  alt=""
                />
              )}
            </div>
            <div className="flex flex-col justify-center items-center">
              <div className=" flex justify-center items-center ">
                {/* {getRegionByTimezone() == "QA" ? (
                <div className="flex justify-between gap-2 h-fit">
                  <img
                  style={{ height: "10rem" }}
                  src={`${assetsUrl}/logos/logo-4.png`}
                  alt=""
                />
                  <img
                    width="155px"
                    src={`${assetsUrl}/logos/NETDENT.png`}
                    alt=""
                  />
                </div>
              ) : (
                <img
                  style={{ height: "10rem" }}
                  src={`${assetsUrl}/logos/logo-4.png`}
                  alt=""
                />
              )} */}
                <img
                  style={{ height: "10rem" }}
                  src={`${assetsUrl}/logos/logo-4.png`}
                  alt=""
                />
              </div>
              <div className=" flex justify-center items-center ">
                <span className="text-slate-200  text-[3rem] font-mono">
                  PappyJoe
                </span>
              </div>
              <div className=" flex flex-col justify-center items-center ">
                {/* <span className="text-fuchsia-100   text-[4.2rem] ">
                Welcome Back
              </span> */}
                <span className="text-slate-300 text-[1.5rem] ">
                  The most user friendly Revenue Cycle Management
                </span>
                <span className="text-slate-300 text-[1.5rem] ">
                  software in the market
                </span>
              </div>
            </div>
            <div></div>
          </div>
        </div>
        <div className="col-span-6 h-[90dvh] w-[100%] rounded-3xl  gradient2">
          <div className="flex flex-col h-[90dvh] col-span-12 bg-white rounded-tr-[150px] rounded-br-3xl ">
            <div className="h-[90%] ">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
